/**
 * Created by cahyo wibowo on 1/4/19
 */

import {upperCase} from 'lodash';

export default (value: string) => {
	return upperCase(value);
}